import { render, staticRenderFns } from "./MonsterSummary.vue?vue&type=template&id=5c9cc69c"
import script from "./MonsterSummary.vue?vue&type=script&lang=js"
export * from "./MonsterSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c9cc69c')) {
      api.createRecord('5c9cc69c', component.options)
    } else {
      api.reload('5c9cc69c', component.options)
    }
    module.hot.accept("./MonsterSummary.vue?vue&type=template&id=5c9cc69c", function () {
      api.rerender('5c9cc69c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MonsterSummary.vue"
export default component.exports